import { render, staticRenderFns } from "./jibenxinxi.vue?vue&type=template&id=81435a02&scoped=true&"
import script from "./jibenxinxi.vue?vue&type=script&lang=js&"
export * from "./jibenxinxi.vue?vue&type=script&lang=js&"
import style0 from "./jibenxinxi.vue?vue&type=style&index=0&id=81435a02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81435a02",
  null
  
)

export default component.exports